<template lang="pug">
.row
    .col-xs-2
        .form-group
            input(
                :disabled="restrictVisibility"
                v-model="effectiveVisibility",
                type="checkbox",
                class="has-value"
            )

    .col-xs-4
        p.m-r-sm._500 {{variant.name}}

    .col-xs-3
        .form-group
            input.form-control(
                v-validate="'decimal:2|min_value:0'",
                type="number",
                name="cost",
                :key="`cost_${variant.id}`",
                :data-vv-scope="`v_${variant.id}`",
                v-model="variant.entry_cost"
                :disabled="restrictPricing"
            )
            small.clear.m-t-xs Standard Cost {{ variant.cost }}
            span.text-danger(v-if="errors.has('cost', `v_${variant.id}`)") {{ errors.first('cost', `v_${variant.id}`) }}

    .col-xs-3
        .form-group
            input.form-control(
                :disabled="restrictPricing"
                v-validate="'decimal:2|min_value:0'",
                type="number",
                :key="`price_${variant.id}`",
                :data-vv-scope="`v_${variant.id}`",
                :placeholder="variant.price"
                name="price",
                v-model="variant.entry_price"
            )
            small.clear.m-t-xs Standard Price {{ variant.price }}
            span.text-danger(v-if="errors.has('price', `v_${variant.id}`)") {{ errors.first('price', `v_${variant.id}`) }}
</template>

<script>
export default {
    props: {
        variant: {
            type: Object,
            required: true,
        },
    },

    computed: {
        restrictPricing() {
            return this.variant.restrict_price_override === 1;
        },

        restrictVisibility() {
            return this.variant.restrict_visibility_override === 1;
        },

        effectiveVisibility: {
            get() {
                return !this.variant.hidden;
            },
            set(val) {
                this.variant.entry_hidden = !val;
            },
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/variant_override.vue